import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {Subject, Subscription} from 'rxjs';
import {bufferTime, filter} from 'rxjs/operators';

@Component({
  selector: 'ims-upload-drop-zone',
  templateUrl: './upload-drop-zone.component.html',
  styleUrls: ['./upload-drop-zone.component.less']
})
export class UploadDropZoneComponent implements OnInit, OnDestroy {

  @Output()
  fileDropped: EventEmitter<NzUploadFile[]> = new EventEmitter();

  fileSubject: Subject<NzUploadFile> = new Subject();
  fileSubscription: Subscription = new Subscription();

  @Input()
  multiple = true;

  @Input()
  accept = 'image/*, .pdf, .xls, .xlsx';

  constructor() {
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.fileSubject.next(file);
    return false;
  };

  ngOnInit() {
    this.fileSubscription = this.fileSubject.asObservable()
      .pipe(
        bufferTime(1000),
        filter((v: any[]) => v.length > 0),
      )
      .subscribe(v => this.fileDropped.emit(v));
  }

  ngOnDestroy(): void {
    this.fileSubscription.unsubscribe();
  }


}
